<div class="content-wrapper-inner">
  <div class="page-content">
    <app-pricing-group-form (onAfterSave)="afterSave()"></app-pricing-group-form>
  </div>
</div>
